import { render, staticRenderFns } from "./PaymentSplitter.vue?vue&type=template&id=19448002&scoped=true"
import script from "./PaymentSplitter.vue?vue&type=script&lang=js"
export * from "./PaymentSplitter.vue?vue&type=script&lang=js"
import style0 from "./PaymentSplitter.vue?vue&type=style&index=0&id=19448002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19448002",
  null
  
)

export default component.exports